export function removeDuplicates(myArr: any, prop: any) {
  return myArr.filter(
    (obj: any, pos: any, arr: any) => arr.map((mapObj: any) => mapObj[prop])
      .indexOf(obj[prop]) === pos,
  );
}
